import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    position: relative;
  }

  .header-background {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .logo-container {
    display: block;
    width: 3.75rem;
    height: 1.5rem;
  }

  .logo-title-container {
    display: flex;
    gap: var(--sds-size-space-800);
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }

  .center-content {
    display: flex;
    align-items: center;
  }

  .buttons-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    align-items: flex-end;
  }

  .menu-controls {
    display: flex;
    flex-direction: row;
    gap: var(--sds-size-space-400);
    align-items: center;
  }

  .action-buttons {
    display: flex;
    flex-direction: row;
    gap: var(--sds-size-space-400);
    align-items: center;
  }

  header {
    position: sticky;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top: 0;
    z-index: 1;
    padding: 1rem;
    gap: 1rem;
    border-bottom: 1px solid var(--sds-color-border-brand-default);
  }

  h1 {
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-heading-size);
    font-weight: var(--sds-typography-weight-medium);
    margin: 0;
    padding-bottom: var(--sds-size-space-150);
    line-height: 1.2;
    color: var(--sds-color-text-default-default);
    letter-spacing: -0.4px;
  }

  @media (min-width: 768px) {
    .logo-title-container {
      flex-direction: row;
      align-items: center;
    }

    .buttons-wrapper {
      flex-direction: row;
      align-items: center;
    }

    .menu-controls {
      order: 2;
    }

    .action-buttons {
      order: 1;
    }

    .logo-container {
      display: none;
    }

    header {
      padding: 2rem 3rem;
      gap: 2rem;
      position: relative;
      z-index: 1;
    }
  }

  @media (max-width: 768px) {
    header {
      align-items: flex-end;
    }

    header.with-background {
      border-bottom: none;
    }

    :host(.has-background) {
      min-height: 280px;
    }
  }
`;
